module.exports = __webpack_public_path__ + "static/media/centro_platea_2.4d9a83dd.jpg";